
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9ccb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9ccb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7kAVY", function(module, exports) {

$parcel$export(module.exports, "base64Decode", () => $55670cfd71ce5f65$export$c62426fdd000a97e);
$parcel$export(module.exports, "base64Encode", () => $55670cfd71ce5f65$export$e510a73ee562749);
$parcel$export(module.exports, "clearStorage", () => $55670cfd71ce5f65$export$d7a0b846d036443e);
$parcel$export(module.exports, "getKey", () => $55670cfd71ce5f65$export$a47fb462a08de82f);
$parcel$export(module.exports, "eq", () => $55670cfd71ce5f65$export$9663ddc1cf085b32);
$parcel$export(module.exports, "getNow", () => $55670cfd71ce5f65$export$3991332aae1fc754);
$parcel$export(module.exports, "getOpen", () => $55670cfd71ce5f65$export$a64c4e0c0a22d56b);
$parcel$export(module.exports, "getTimestamp", () => $55670cfd71ce5f65$export$3c95c4c8b671ef0);
$parcel$export(module.exports, "gtagEvent", () => $55670cfd71ce5f65$export$53ae40010cae7216);
$parcel$export(module.exports, "isActive", () => $55670cfd71ce5f65$export$39e04e72f972b885);
/**
 * NB Event Queue | Shared functions
 *
 * @copyright 2023 NB Communication Ltd
 *
 */ 
var $cWZn2 = parcelRequire("cWZn2");
const $55670cfd71ce5f65$export$c62426fdd000a97e = (str)=>atob(str);
const $55670cfd71ce5f65$export$e510a73ee562749 = (str)=>btoa(str);
const $55670cfd71ce5f65$export$d7a0b846d036443e = (keys)=>keys.forEach((key)=>localStorage.removeItem($55670cfd71ce5f65$export$a47fb462a08de82f(key)));
const $55670cfd71ce5f65$export$9663ddc1cf085b32 = (e, q, cb)=>fetch(`${(0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).queue}/.netlify/functions/eq?e=${e}&q=${$55670cfd71ce5f65$export$e510a73ee562749(JSON.stringify(q))}`).then((response)=>response.json()).then((data)=>cb ? cb.call(null, data) : console.log(data));
const $55670cfd71ce5f65$export$a47fb462a08de82f = (key)=>`nb-event-queue${key ? `-${key}` : ''}`;
const $55670cfd71ce5f65$export$3991332aae1fc754 = ()=>{
    return +new Date();
};
const $55670cfd71ce5f65$export$a64c4e0c0a22d56b = (data)=>data.open - data.prequeue * 60000;
const $55670cfd71ce5f65$export$3c95c4c8b671ef0 = (key)=>parseInt($55670cfd71ce5f65$export$c62426fdd000a97e(localStorage.getItem($55670cfd71ce5f65$export$a47fb462a08de82f(key)) ?? $55670cfd71ce5f65$export$e510a73ee562749(0)));
const $55670cfd71ce5f65$export$53ae40010cae7216 = (params)=>'gtag' in window ? gtag('event', 'nb_event_queue', params) : null;
const $55670cfd71ce5f65$export$39e04e72f972b885 = (data, ts)=>data.open && ts > $55670cfd71ce5f65$export$a64c4e0c0a22d56b(data) && data.close && ts < data.close;

});
parcelRegister("cWZn2", function(module, exports) {
module.exports = JSON.parse("{\"id\":42,\"open\":\"2026-03-16T18:00:00+00:00\",\"close\":\"2026-03-16T18:45:00+00:00\",\"prequeue\":15,\"queue\":\"https://sff-queue.netlify.app\",\"entry\":\"https://www.shetlandfolkfestival.com/queue\",\"home\":\"https://www.shetlandfolkfestival.com/\",\"event\":\"https://www.shetlandfolkfestival.com/tickets\"}");

});


/**
 * NB Event Queue | Queue
 *
 * @copyright 2023 NB Communication Ltd
 *
 */ 
var $7kAVY = parcelRequire("7kAVY");
var $8e4060b1b31533eb$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $8e4060b1b31533eb$var$url = new URL(import.meta.resolve("8uM1m"));
$8e4060b1b31533eb$exports = $56b621a6dd25b2cb$exports($8e4060b1b31533eb$var$url.toString(), $8e4060b1b31533eb$var$url.origin, true);


function $78966ba84e02bc8e$var$nbEventQueue() {
    const unhide = (key)=>document.getElementById((0, $7kAVY.getKey)(key)).hidden = '';
    const error = (msg)=>{
        const key = 'error';
        document.getElementById((0, $7kAVY.getKey)(key)).innerText = msg;
        unhide(key);
    };
    let session = window.location.search.replace(/\?session=(.*?)$/, '$1');
    if (session) // Set this session in storage
    localStorage.setItem((0, $7kAVY.getKey)('session'), session);
    else // Get the session from storage
    session = localStorage.getItem((0, $7kAVY.getKey)('session'));
    if (session) try {
        // Get the session data
        const data = JSON.parse((0, $7kAVY.base64Decode)(session));
        if (data) {
            if (data.reset) {
                localStorage.removeItem((0, $7kAVY.getKey)('out'));
                delete data.reset;
            }
            let now = (0, $7kAVY.getNow)();
            // If the queue is open, or prequeue
            if ((0, $7kAVY.isActive)(data, now)) {
                const check = (ts)=>{
                    now = (0, $7kAVY.getNow)();
                    const minutes = (key, value)=>{
                        value = Math.ceil(value / 1000 / 60);
                        document.getElementById((0, $7kAVY.getKey)(`${key}-time`)).innerText = `${value} minute${value === 1 ? '' : 's'}`;
                        unhide(key);
                    };
                    if (now < data.open) // Prequeue
                    minutes('prequeue', data.open - now);
                    else {
                        // Queue is open
                        minutes('wait', ts - now);
                        document.getElementById((0, $7kAVY.getKey)('prequeue')).hidden = 'hidden';
                        if (ts < now) (0, $7kAVY.eq)('pass', {
                            id: data.id,
                            ts: data.ts,
                            q: ts
                        }, (result)=>{
                            if (result.status === 200) {
                                (0, $7kAVY.clearStorage)([
                                    'session',
                                    'out',
                                    'wait'
                                ]);
                                window.location.href = `${data.event}?token=${(0, $7kAVY.base64Encode)([
                                    result.response,
                                    (0, $7kAVY.base64Encode)(ts)
                                ].join('.'))}`;
                            }
                        });
                    }
                };
                const checkTimestamp = (ts)=>{
                    // Check immediately
                    check(ts);
                    // Check every second using a worker
                    const intervalWorker = new Worker($8e4060b1b31533eb$exports);
                    intervalWorker.onmessage = ()=>check(ts);
                };
                const ts = (0, $7kAVY.getTimestamp)('out');
                if (ts && ts > data.open && ts < data.close) // The out timestamp is in the window, start checking
                checkTimestamp(ts);
                else {
                    if (ts) // remove old timestamp if it exists
                    localStorage.removeItem((0, $7kAVY.getKey)('out'));
                    // Get an out timestamp
                    (0, $7kAVY.eq)('place', {
                        open: data.open,
                        close: data.close
                    }, (result)=>{
                        if (result.status === 200) {
                            const place = parseInt(result.response);
                            localStorage.setItem((0, $7kAVY.getKey)('out'), (0, $7kAVY.base64Encode)(place));
                            (0, $7kAVY.gtagEvent)({
                                wait: Math.ceil((place - now) / 1000)
                            }); //todo wait time from open
                            checkTimestamp(place);
                        }
                    });
                }
            } else // Queue is closed
            unhide('closed');
        }
    } catch (e) {
        localStorage.removeItem((0, $7kAVY.getKey)('session'));
        error(e);
    }
    else error(`Sorry, you have arrived here incorrectly.\nPlease return to the event and see if you come back the right way...`);
}
document.addEventListener('DOMContentLoaded', $78966ba84e02bc8e$var$nbEventQueue);


//# sourceMappingURL=repo.ff26c2f1.js.map
